const sellInquiryFormData = (state) => {
	return state.sellInquiryForm.data
}

const sellInquiryFormFileData = (state) => {
	return state.sellInquiryForm.fileData
}

const isLoadingSellInquiryFormData = (state) => {
	return state.sellInquiryForm.isLoading
}

const isSavingSellInquiryFormData = (state) => {
	return state.sellInquiryForm.isSaving
}

export {
	sellInquiryFormData,
	sellInquiryFormFileData,
	isLoadingSellInquiryFormData,
	isSavingSellInquiryFormData
}
